import React from 'react';
import { each } from 'lodash';
import qs from 'query-string';
import PropTypes from 'prop-types';
import FitContent from 'modules/common/FitContent';
import { usePersistState } from 'utils/usePersistState';
import { getPartnerById } from '../actions';
import { AppContext } from '../context';
import ConcentPage from './ConcentPage';
import { appendCss, THEMES } from '../hooks/useTheme';

function InitContainer({ children }) {
  const [error, setError] = React.useState(null);
  const [partner, setPartner] = React.useState(false);
  const [session] = usePersistState('user-session', null, {
    keepOnUnmount: true,
  });
  const [theme, setTheme] = React.useState(null);
  React.useEffect(() => {
    const query = qs.parse(window.location.search);
    if (!query.partner_id && !session) {
      setError({
        message: 'Invalid URL',
      });
      return;
    }
    getPartnerById(session?.partner_id || query.partner_id, (res) => {
      appendCss('theme-style', THEMES[res.theme] || THEMES.default);
      setTheme(res.theme);
      each(res.colors, (v, k) => {
        document.documentElement.style.setProperty(k, v);
      });
      setPartner(res);
    });
  }, [session, setPartner, setError, setTheme]);

  if (partner?.error) {
    return (
      <FitContent>
        <div className="m-auto">
          {partner?.data?.error_description || 'Invalid URL'}
        </div>
      </FitContent>
    );
  }

  if (partner && !session) {
    return (
      <AppContext.Provider value={{ partner, theme }}>
        <FitContent>
          <ConcentPage partner={partner} />
        </FitContent>
      </AppContext.Provider>
    );
  }

  if (partner && session) {
    return (
      <AppContext.Provider value={{ partner, theme }}>
        {children}
      </AppContext.Provider>
    );
  }

  return (
    <FitContent>
      <div className="m-auto">{error?.message || 'Connecting...'}</div>
    </FitContent>
  );
}

InitContainer.defaultProps = {
  children: {},
};

InitContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default InitContainer;
